import { ApiGet, ApiPost } from "./ApiRequest"
import { CarePlanEventResponse } from "../forms/types"

export const getCarePlanBYPatientId = async (
    patientId: number,
    { upcomingPage, pastPage }: { upcomingPage: number; pastPage: number }
) => {
    const instance = new ApiGet<CarePlanEventResponse[]>(
        `/care-plan-v1/${patientId}?upcoming-page=${upcomingPage}&past-page=${pastPage}`
    )
    instance.callerName = getCarePlanBYPatientId.name
    return instance.run()
}
